import { render, staticRenderFns } from "./AuthAmeliPro.vue?vue&type=template&id=60df2039"
import script from "./AuthAmeliPro.vue?vue&type=script&lang=ts"
export * from "./AuthAmeliPro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports